export default "__VITE_ASSET__df885238__"